<template>
  <v-container>
    <v-row class="justify-center d-flex mt-n16">
      <v-col lg="8" md="8" class="mx-auto">
        <v-card class="card-shadow border-radius-xl">
          <div class="card-padding text-center">
<!--            <h5 class="text-h5 text-typo font-weight-bold">Register with NEC-Construction Zimbabwe</h5>-->
            <h5 class="text-h5 text-typo font-weight-bold">Register with NEC Construction</h5>
          </div>
          <div class="d-flex">
            <v-btn
              icon
              outlined
              rounded
              color="transparent"
              width="60px"
              height="60px"
              class="ms-auto me-3 btn-outline-light border-radius-md"
            >

            </v-btn>
            <v-btn
              icon
              outlined
              rounded
              color="transparent"
              width="60px"
              height="60px"
              class="me-3 btn-outline-light border-radius-md"
            >

            </v-btn>
            <v-btn
              icon
              outlined
              rounded
              color="transparent"
              width="60px"
              height="60px"
              class="me-auto btn-outline-light border-radius-md"
            >

            </v-btn>
          </div>
          <div class="mt-2 position-relative text-center">
            <p
              class="
                text-sm
                font-weight-bold
                mb-2
                text-secondary text-border
                d-inline
                z-index-2
                bg-white
                px-3
              "
            >

            </p>
          </div>
          <v-form v-model="valid" @submit.prevent="RegisterRequest">
          <div class="card-padding pb-4">
            <label class="text-xs text-typo font-weight-bolder ms-1">Select the region you want to register with</label>
            <v-select
                v-model="region"
                class="
              input-style
              font-size-input
              border border-radius-md
              placeholder-lighter
              text-color-light
              mb-4
              mt-2
            "
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="Select your preferred region"
                :rules="[rules.required]"
                :items="[ 'Harare', 'Bulawayo', 'Gweru', 'Mutare','Masvingo']"
            ></v-select>

            <label class="text-xs text-typo font-weight-bolder ms-1">Email address </label>
            <v-text-field
                v-model="email"
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="name@company.co.zw"
                class="
            input-style
            font-size-input
            border border-radius-md
            placeholder-lighter
            text-color-light
            mb-4
            mt-2
          "
                :rules="[rules.required, rules.email]"
            >
            </v-text-field>

            <label class="text-xs text-typo font-weight-bolder ms-1">Trading name</label>
            <v-text-field
                v-model="trading_as"
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="Company XYZ"
                class="
            input-style
            font-size-input
            border border-radius-md
            placeholder-lighter
            text-color-light
            mb-4
            mt-2
          "
                :rules="[rules.required]"
            >
            </v-text-field>

            <label class="text-xs text-typo font-weight-bolder ms-1">Type of my business</label>
            <v-select
                v-model="business_type"
                class="
              input-style
              font-size-input
              border border-radius-md
              placeholder-lighter
              text-color-light
              mb-4
              mt-2
            "
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="Select your business type"
                :rules="[rules.required]"
                :items="['Sole Proprietorship', 'Corporate body partnership', 'Limited Liability Company']"
            ></v-select>

            <label class="text-xs text-typo font-weight-bolder ms-1">Names of partners, proprietors, directors (comma seperated)</label>
            <v-text-field
                v-model="director_names"
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="John Doe, Mike Me, Mary Drew, Susan Tim"
                class="
                  input-style
                  font-size-input
                  border border-radius-md
                  placeholder-lighter
                  text-color-light
                  mb-4
                  mt-2
                "
                :rules="[rules.required]"
            >
            </v-text-field>

            <label class="text-xs text-typo font-weight-bolder ms-1">Residential address of partners, proprietors, directors (comma seperated)</label>
            <v-textarea
                v-model="director_address"
                hide-details
                outlined
                rows="3"
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                placeholder="13 Close Suburb Harare Zimbabwe , 236 6th Street Suburb Harare Zimbabwe, 67 Name Flats Suburb City Zimbabwe"
                class="
          input-style
          font-size-input
          border border-radius-md
          placeholder-lighter
          text-color-light
          mb-4
          mt-2
        "
                :rules="[rules.required]"
            >
            </v-textarea>

            <label class="text-xs text-typo font-weight-bolder ms-1">Business address </label>
            <v-text-field
                v-model="business_address"
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="13 Street Name Harare Zimbabwe"
                class="
          input-style
          font-size-input
          border border-radius-md
          placeholder-lighter
          text-color-light
          mb-4
          mt-2
        "
                :rules="[rules.required]"
            >
            </v-text-field>

            <label class="text-xs text-typo font-weight-bolder ms-1">Workshop or yard address </label>
            <v-text-field
                v-model="workshop_address"
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="13 Street Name Harare Zimbabwe"
                class="
          input-style
          font-size-input
          border border-radius-md
          placeholder-lighter
          text-color-light
          mb-4
          mt-2
        "
                :rules="[rules.required]"
            >
            </v-text-field>

            <label class="text-xs text-typo font-weight-bolder ms-1">Trades to be carried out </label>
            <v-text-field
                v-model="trades_performed"
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="Roofing, Plumbing, Bricklaying etc"
                class="
          input-style
          font-size-input
          border border-radius-md
          placeholder-lighter
          text-color-light
          mb-4
          mt-2
        "
                :rules="[rules.required]"
            >
            </v-text-field>

            <label class="text-xs text-typo font-weight-bolder ms-1">Workman's Compensation EC Number (NSSA)</label>
            <v-text-field
                v-model="workman_ecnumber"
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="CON123212"
                class="
          input-style
          font-size-input
          border border-radius-md
          placeholder-lighter
          text-color-light
          mb-4
          mt-2
        "
                :rules="[rules.required]"
            >
            </v-text-field>
            <label class="text-xs text-typo font-weight-bolder ms-1">Upload Registration Proof of Payment <b>(USD$123)</b></label>
            <input class="mt-3" type="file" ref="myFile" hidden>
            <v-file-input
                v-model="pops"
                placeholder="Attach your POP"
                multiple
                outlined
                prepend-icon="mdi-paperclip"
                hide-details
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                class="
                  input-style
                  font-size-input
                  border border-radius-md
                  placeholder-lighter
                  text-color-dark
                  mb-4
                  mt-2
                "
                :rules="[rules.required]"
            >
              <template v-slot:selection="{ text }">
                <v-chip
                    small
                    label
                    color="light"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <label class="text-xs text-typo font-weight-bolder ms-1">NSSA Registration Certificate / Receipt with SSR Number</label>
            <input class="mt-3" type="file" ref="myFile" hidden>
            <v-file-input
                v-model="nssaDocs"
                placeholder="Attach your NSSA Certificate"
                multiple
                outlined
                prepend-icon="mdi-paperclip"
                hide-details
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                class="
                  input-style
                  font-size-input
                  border border-radius-md
                  placeholder-lighter
                  text-color-dark
                  mb-4
                  mt-2
                "
                :rules="[rules.required]"
            >
              <template v-slot:selection="{ text }">
                <v-chip
                    small
                    label
                    color="light"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <label class="text-xs text-typo font-weight-bolder ms-1">Copy of Director's National ID </label>
            <input class="mt-3" type="file" ref="myFile" hidden>
            <v-file-input
                v-model="directorIDS"
                placeholder="Attach your director ID"
                multiple
                outlined
                prepend-icon="mdi-paperclip"
                hide-details
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                class="
                  input-style
                  font-size-input
                  border border-radius-md
                  placeholder-lighter
                  text-color-dark
                  mb-4
                  mt-2
                "
                :rules="[rules.required]"
            >
              <template v-slot:selection="{ text }">
                <v-chip
                    small
                    label
                    color="light"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <label class="text-xs text-typo font-weight-bolder ms-1">Copy of Director's Proof of Residence  </label>
            <input class="mt-3" type="file" ref="myFile" hidden>
            <v-file-input
                v-model="directorPORs"
                placeholder="Attach your director ID"
                multiple
                outlined
                prepend-icon="mdi-paperclip"
                hide-details
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                class="
                  input-style
                  font-size-input
                  border border-radius-md
                  placeholder-lighter
                  text-color-dark
                  mb-4
                  mt-2
                "
            >
              <template v-slot:selection="{ text }">
                <v-chip
                    small
                    label
                    color="light"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <label class="text-xs text-typo font-weight-bolder ms-1">Copy of CR14  </label>
            <input class="mt-3" type="file" ref="myFile" hidden>
            <v-file-input
                v-model="copyOfCR14"
                placeholder="Attach your copy of Company CR14"
                multiple
                outlined
                prepend-icon="mdi-paperclip"
                hide-details
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                class="
                  input-style
                  font-size-input
                  border border-radius-md
                  placeholder-lighter
                  text-color-dark
                  mb-4
                  mt-2
                "
            >
              <template v-slot:selection="{ text }">
                <v-chip
                    small
                    label
                    color="light"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-btn
                :disabled="!valid"
                elevation="0"
                :ripple="false"
                height="43"
                class="
          font-weight-bold
          text-uppercase
          btn-primary
          bg-gradient-secondary
          py-2
          px-6
          me-2
          mt-7
          mb-2
          w-100
        "
                color="#5e72e4"
                small
                @click="RegisterRequest()"
            >Sign Up</v-btn
            >
            <hr>
            <div class="text-center">
              <p class="text-sm text-body mt-3 mb-0">
                Already have an account?
                <a
                    @click="goTo()"
                    class="
              text-secondary text-gradient text-decoration-none
              font-weight-bold
            "
                >Sign In</a
                >
              </p>
            </div>
          </div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
        v-model="successDialog"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Success
        </v-card-title>

        <v-card-text>
          Your application has been submitted successfully. Our team will review it and get back to you soon via the email address you provided.
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="green darken-1"
              text
              outlined
              @click="goTo()"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="errorDialog"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Error
        </v-card-title>

        <v-card-text>
          Please check if you have uploaded all the required documents
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="danger darken-1"
              text
              outlined
              @click="errorDialog = false"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            size="64"
        />
      </v-overlay>
    </div>
  </v-container>

</template>
<script>
import {
  mapState,
} from 'vuex'
import axios from 'axios'
export default {
  name: "sign-up-basic",
  data() {
    return {
      pops:[],
      valid: true,
      nssaDocs:[],
      directorIDS:[],
      directorPORs:[],
      copyOfCR14:[],
      checkbox: false,
      successDialog: false,
      errorDialog: false,
      overlay:false,
      id_number: "",
      email: "",
      username: "",
      firstname: "",
      lastname: "",
      mobile_number: "",
      password: "Password123*",
      trading_as: "",
      business_type: "",
      region: "",
      registration_number: "",
      business_address: "",
      director_address: "",
      workshop_address: "",
      trades_performed: "",
      workman_ecnumber: "",
      director_names:"",
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length >= 10 || 'Max 10 characters',
        counter_id: value => value.length >= 11 || 'Max 11 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
    };
  },
  computed: {
    ...mapState(['base_url']),
  },
  methods: {
    async Register() {
      this.overlay = true;
      let file = this.pops[0]
      console.log(file)
      await new Promise(resolve => setTimeout(resolve, 2000));
      let JWTToken = this.$store.getters.accessToken;
      console.log(this.$store.getters.accessToken);
      const payload = {
        "director_names": this.director_names,
        "email": this.email,
        "username": this.email,
        "id_number": this.email,
        "password": "Password123*",
        "type": "REGISTRATION",
        "trading_as": this.trading_as,
        "business_type": this.business_type,
        "business_address": this.business_address,
        "director_address": this.director_address,
        "workshop_address": this.workshop_address,
        "trades_performed": this.trades_performed,
        "workman_ecnumber": this.workman_ecnumber,
      };
      console.log(payload);
      const config = {
        method: "post",
        url: this.base_url + "/auth/register/",
        headers: {
          // Authorization: `Bearer ${JWTToken}`,
          'Content-Type': 'application/json',
          // 'Content-Type': 'multipart/form-data'
        },
        data: payload
      };

      axios(config)
          .then((response) => {
            if (response.status === 201) {
              if (this.pops.length > 0 || this.nssaDocs.length > 0 || this.directorIDS.length > 0 || this.directorPORs.length > 0 || this.copyOfCR14.length > 0) {
                let formData = new FormData();
                let token = response.data.token;
                formData.append('pop', this.pops[0]);
                formData.append('nssa_doc', this.nssaDocs[0]);
                formData.append('director_id', this.directorIDS[0]);
                formData.append('director_por', this.directorPORs[0]);
                formData.append('cr14', this.copyOfCR14[0]);
                formData.append('email', this.email);
                const config = {
                  method: "post",
                  url: this.base_url + "/auth/add-pop/",
                  headers: {
                    Authorization: `Bearer ${token}`,
                    //'Content-Type': 'application/json',
                    'Content-Type': 'multipart/form-data'
                  },
                  data: formData
                };
                axios(config)
                    .then((response) => {
                      console.log(response)
                    }).catch((error) => {
                      console.log(error)
                });
              }
              else{
                console.log("NO FILE")
              }
              this.overlay = false;
              this.successDialog = true
            }
          })
          .catch((error) => {
            if (error.status === 400) {
              this.errorDialog = true
              this.overlay = false;
            }
            else {
              this.errorDialog = true
              this.overlay = false;
            }
          });

    },
    async RegisterRequest() {
      this.overlay = true;
      await new Promise(resolve => setTimeout(resolve, 2000));
      console.log(this.pops.length)
      console.log(this.nssaDocs.length)
      console.log(this.directorIDS.length)
      console.log(this.directorPORs.length)
      console.log(this.copyOfCR14.length)
      if (this.pops.length > 0 || this.nssaDocs.length > 0 || this.directorIDS.length > 0 || this.directorPORs.length > 0 || this.copyOfCR14.length > 0) {
        let formData = new FormData();
        formData.append('pop', this.pops[0]);
        formData.append('nssa_doc', this.nssaDocs[0]);
        formData.append('director_id', this.directorIDS[0]);
        formData.append('director_por', this.directorPORs[0]);
        formData.append('cr14', this.copyOfCR14[0]);
        formData.append('email', this.email);
        // const payload = {
        //   "director_names": this.director_names,
        //   "email": this.email,
        //   "username": this.email,
        //   "id_number": this.email,
        //   "password": "Password123*",
        //   "type": "REGISTRATION",
        //   "trading_as": this.trading_as,
        //   "business_type": this.business_type,
        //   "business_address": this.business_address,
        //   "director_address": this.director_address,
        //   "workshop_address": this.workshop_address,
        //   "trades_performed": this.trades_performed,
        //   "workman_ecnumber": this.workman_ecnumber,
        // };
        formData.append('director_names', this.director_names);
        formData.append('email', this.email);
        formData.append('username', this.email);
        formData.append('id_number', this.email);
        formData.append('password', "Password123*");
        formData.append('type', "REGISTRATION");
        formData.append('trading_as', this.trading_as);
        formData.append('business_type', this.business_type);
        formData.append('business_address', this.business_address);
        formData.append('director_address', this.director_address);
        formData.append('workshop_address', this.workshop_address);
        formData.append('trades_performed', this.trades_performed);
        formData.append('workman_ecnumber', this.workman_ecnumber);
        formData.append('region', this.region);
        const config = {
          method: "post",
          url: this.base_url + "/auth/register-request/",
          headers: {
            // Authorization: `Bearer ${JWTToken}`,
            'Content-Type': 'multipart/form-data'
            // 'Content-Type': 'multipart/form-data'
          },
          data: formData
        };

        axios(config)
            .then((response) => {
              if (response.status === 200) {
                console.log(response)
                this.overlay = false;
                this.successDialog = true
              }
            })
            .catch((error) => {
              if (error.status === 400) {
                this.errorDialog = true
                this.overlay = false;
              }
              else {
                this.errorDialog = true
                this.overlay = false;
              }
            });
      }
      else{
        this.overlay = false;
        this.errorDialog = true
      }


    },
    async Register1(){
      this.overlay = true
      let Todaydate = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      console.log(Todaydate)
      this.uploadData =
        {
          "director_names": this.director_names,
          "email": this.email,
          "username": this.email,
          "password": "Password123*",
          "trading_as": this.trading_as,
          "business_type": this.business_type,
          "business_address": this.business_address,
          "director_address": this.director_address,
          "workshop_address": this.workshop_address,
          "trades_performed": this.trades_performed,
          "workman_ecnumber": this.workman_ecnumber
        }
      console.log(this.uploadData)
      await new Promise((resolve) => setTimeout(resolve, 3000));
      const JWTToken = this.$store.getters.accessToken
      await axios
          .post( this.base_url + "/auth/register/", this.uploadData)
          .then((response) => {
            console.log(response)
            this.overlay = true;
            if (response.status === 201) {
              console.log(response.data);
              // this.$router.push("/user/dashboard").catch(() => {})
            } else if (response.status === 404){
              this.overlay = false;
            }
            else {
              this.overlay = false;
              this.errorUpload = true;
              console.log(response)
            }
          })
          .catch((error) => {
            if (error.response.status === 400) {
              this.overlay = false;
              this.errorUpload = true;
            } else if (error.response.status === 404) {
              this.overlay = false;
              this.errorUpload = true;
            } else if (error.response.status === 500) {
              this.overlay = false;
              this.errorUpload = true;
            }else{
              this.overlay = false;
              this.errorUpload = true;
            }
          });

    },
    goTo(){
      this.$router.replace("/login");
    }

  },
};
</script>
